import { useEffect, useState } from 'react';
import { GridInitialState } from '@mui/x-data-grid-pro';
import {
  User,
  fetchUsers,
  getCruxUsersLoadingSubject,
  getCruxUsersSubject,
  getUserSubject
} from '../../../../../store/User';
import { DefaultUserGridColumnDefs } from '../../ColumnDefs/UserGridColumnDefs';
import { UpstackDataGrid } from '../../../../Compounds/UpstackDataGrid/UpstackDataGrid';
import { getGridColumns, getInitialState } from '../../../../Compounds/UpstackDataGrid/helpers';
import { getDefaultPreferences, GridPreferences } from '../../../../../store/UserCustomizations';
import { GridCustomColDef } from '../../../../types';
import { ComponentSpinner } from '../../../../Compounds/Loading/ComponentSpinner';
import { PageLayout } from '../../../../PageLayout';

export const UserTab = () => {
  const [usersLoading, setUsersLoading] = useState<boolean>(false);
  const [users, setUsers] = useState<User[]>([]);
  const [userColumns, setUserColumns] = useState<GridCustomColDef[]>(DefaultUserGridColumnDefs);
  const [gridSettings, setGridSettings] = useState<GridPreferences>(
    getDefaultPreferences()?.content['userGrid'] as GridPreferences
  );
  const [initialState, setInitialState] = useState<GridInitialState>();

  useEffect(() => {
    const loadingSubscription = getCruxUsersLoadingSubject().subscribe((loading) => setUsersLoading(loading));
    const usersSub = getCruxUsersSubject().subscribe((usrs) => setUsers(usrs));
    const userSub = getUserSubject().subscribe((usr) => {
      if (usr?.preferences?.content?.userGrid) {
        setGridSettings(usr.preferences.content.userGrid);
        const state = getInitialState(usr.preferences.content.userGrid, DefaultUserGridColumnDefs, 'userGrid');
        setInitialState(state);
      }
    });

    fetchUsers();

    return () => {
      if (loadingSubscription) loadingSubscription.unsubscribe();
      if (usersSub) usersSub.unsubscribe();
      if (userSub) userSub.unsubscribe();
    };
  }, []);

  useEffect(() => {
    if (!usersLoading && users.length > 0) {
      setUserColumns(getGridColumns(users, DefaultUserGridColumnDefs, 'userGrid'));
    }
  }, [usersLoading, users.length]);

  return (
    <PageLayout
      className="w-full"
      dataTestId="user-page"
      dataCy="user-page-card"
      pageTitle="">
      <div data-testid="user-management">
        <>
          {!initialState ||
            (usersLoading && (
              <div className="flex h-[45rem] m-auto">
                <ComponentSpinner label="Loading data..." />
              </div>
            ))}
          {initialState && !usersLoading && (
            <UpstackDataGrid
              title="Users"
              rows={users}
              columns={userColumns}
              page="userGrid"
              gridSettings={gridSettings}
              showSearch={false}
              initialState={initialState}
              apiFilter={false}
            />
          )}
        </>
      </div>
    </PageLayout>
  );
};
